import React from 'react';
import styled from 'styled-components/macro';

interface Props {
	className?: string;
	children: React.ReactNode;
}

const BodyText = ({ children, className }: Props) => {
	return <StyledBodyText className={className}>{children}</StyledBodyText>;
};

const StyledBodyText = styled.p`
	font-family: 'museo-sans';
	font-style: normal;
	font-weight: normal;
	font-size: 13px;
	line-height: 15px;
	text-align: center;
	color: #333333;
`;

export default BodyText;
